/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Company_Tax_CodeInputs */

const vi_sinp_company_tax_code = /** @type {(inputs: Sinp_Company_Tax_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MST`)
};

/**

* @param {Sinp_Company_Tax_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_company_tax_code = /** @type {((inputs?: Sinp_Company_Tax_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Company_Tax_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_company_tax_code(inputs)
});